module.exports = __webpack_public_path__ + "static/media/fruit.6509cbd2.png";